import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { JeevesOrderCardListComponent, JeevesOrderActionConfigService } from 'gung-standard-jeeves';
import { LocationConfigService, PriceConfigService } from 'gung-standard';

@Component({
  selector: 'tylo-tylo-jeeves-order-card-list',
  templateUrl: './tylo-jeeves-order-card-list.component.html',
  styleUrls: ['./tylo-jeeves-order-card-list.component.css']
})
export class TyloJeevesOrderCardListComponent extends JeevesOrderCardListComponent {
  constructor(
    public configService: JeevesOrderActionConfigService,
    protected locationConfigService: LocationConfigService,
    public priceConfigService: PriceConfigService,
    public translateService: TranslateService
  ) {
    super(configService, locationConfigService, priceConfigService);
  }

  getTrackOrderLink(orderId: string): string {
    return `https://www.unifaunonline.com/ext.uo.${this.translateService.currentLang}.track?key=0000082967&reference=Our%20ref:%20${orderId}`;
  }
}
